// import {Form, useEditContext, useResourceContext} from 'ra-core';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {useMutation} from '@tanstack/react-query';
import {postRequest} from '@/lib/client';
import TextInput from '@/components/refinedev/TextInput';
import useDialogState from 'hooks/useDialogState';
import {Button} from '@/shadcn_components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from '@/shadcn_components/ui/dialog';
import Spinner from '@/components/basic/Spinner';
import {BaseID} from '@/hooks/types';
import {FormProvider, useForm} from 'react-hook-form';
import {useApiService} from '@/lib/ApiService';
import { defaultMutationOptions } from '../_utils';

const schema = {
  username: yup.string().nullable().required('Cần nhập tên đăng nhập'),
  password: yup
    .string()
    .nullable()
    .required('Cần nhập mật khẩu')
    .min(6, 'Mật khẩu ít nhất 6 ký tự'),
  // .min(4, 'Password length should be at least 4 characters')
  // .max(12, 'Password cannot exceed more than 12 characters'),
  password_confirmation: yup
    .string()
    .nullable()
    .required('Cần xác nhận mật khẩu')
    .min(6, 'Mật khẩu ít nhất 6 ký tự')
    // .min(4, 'Password length should be at least 4 characters')
    // .max(12, 'Password cannot exceed more than 12 characters')
    .oneOf([yup.ref('password')], 'Mật khẩu không khớp'),
};

const changePasswordResolver = yupResolver(
  yup
    .object()
    .shape({
      password: schema.password,
      password_confirmation: schema.password_confirmation,
    })
    .required(),
);

type ChangeAccountPasswordButtonProps = {
  // resource: string; //resource like parents, staffs, students, ...
  // id: BaseID; //id of the userable model
  user: any;
};

export const ChangeAccountPasswordButton = (props: ChangeAccountPasswordButtonProps) => {
  const {user} = props;
  const dialogState = useDialogState();

  const apiService = useApiService();

  const mutation = useMutation<any, any, any>({
    ...defaultMutationOptions,
    mutationFn: payload =>
      apiService.users.changePassword(user.id, payload.password, payload.password_confirmation),    
  });

  const useFormResults = useForm({
    defaultValues: {
      username: user.username,
      password: '',
      password_confirmation: '',
    },
    resolver: changePasswordResolver,
  });

  async function changePassword(data) {
    try {
      const resp = await mutation.mutateAsync({
        id: user.id,
        ...data,
      });
      dialogState.closeDialog();
    } catch (err) {}
  }

  return (
    <>
      <Button className="w-48" color="blue" type="button" onClick={dialogState.openDialog}>
        Đổi mật khẩu
      </Button>
      <Dialog open={dialogState.open} onOpenChange={dialogState.setOpen}>
        <DialogContent>
          <FormProvider {...useFormResults}>
            <form onSubmit={useFormResults.handleSubmit(changePassword)}>
              <DialogHeader>Đổi mật khẩu</DialogHeader>

              <div className="max-w-xl flex flex-col gap-y-4">
                <TextInput source="username" label="Tên đăng nhập" disabled />
                <TextInput source="password" label="Mật khẩu" type="password" />
                <TextInput
                  source="password_confirmation"
                  label="Xác nhận mật khẩu"
                  type="password"
                />
              </div>

              <DialogFooter>
                <Button
                  className="w-48"
                  color="blue"
                  type="submit"
                  // loading={mutation.isLoading}
                  disabled={mutation.isLoading}>
                  {mutation.isLoading && <Spinner />}
                  Đổi mật khẩu
                </Button>
              </DialogFooter>
            </form>
          </FormProvider>
        </DialogContent>
      </Dialog>
    </>
  );
};
